var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-upload',{attrs:{"action":"","on-remove":_vm.handleRemove,"http-request":_vm.upload,"file-list":_vm.explainFileList}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v(_vm._s(_vm.buttonText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }